enum IntegrationName {
  ABI = "abi",
  DELIVERECT = "deliverect",
  PARTNER = "partner"
}

export default IntegrationName;
